<div class="unaccompanied-minor" *ngIf="unaccompaniedMinorServices?.length || loading()">
  <lx-card-container
    type="unaccompaniedMinor"
    i18n-title
    title="Alpadia UM Services"
    [loading]="loading()"
    [actionMode]="selectedUnaccompaniedMinorRows?.length ? 'remove' : 'add'"
    [disabled]="!!!selectedUnaccompaniedMinorRows?.length"
    [endPrice]="endPrice"
    [price]="price"
    [discount]="discount"
    [currency]="currency?.()"
    [gaEventName]="dataLayerEventName$ | async"
    (buttonClick)="addRemoveUnaccompaniedMinor()"
    [attr.data-qa]="'unaccompaniedMinor_header'"
  >
    <div class="unaccompanied-minor__paragraph" i18n>
      Peace of mind while your child travels is key! If you've booked the Unaccompanied Minor (UM) Service with the airline, this mandatory fee applies.
    </div>
    <div class="card-container-highlighted">
      <div *ngIf="selectedUnaccompaniedMinorRows?.length" i18n>Arrival & Departure</div>
    </div>
  </lx-card-container>
</div>
